import React from 'react';

import Loading from 'assets/svg/loading.component.svg';
import './loading-icon.scss';

const LoadingIcon = () => <div styleName="loading"><Loading /></div>;

export default LoadingIcon;
